import RequestService from "@/configurations/AxiosConfig";
import { ICreateDepartmentRequest, IEditDepartmentRequest } from "@/types/type";

const endpoints = {
  departments: 'departments',
  companiesDepartments: 'departments/company-departmans',
  departmentsByCompanyId: (companyId: string | number) => `departments/byCompanyId/${companyId}`,
};

const DepartmentsService = {
  getAllDepartments: () => RequestService.get(endpoints.departments),
  updateDepartments: async (id: string | number, data: IEditDepartmentRequest) => RequestService.patch(`${endpoints.companiesDepartments}/${id}`, data),
  createDepartment: (data:ICreateDepartmentRequest ) => RequestService.post(endpoints.departments, data),
  deleteDepartment: (id: string | number) => RequestService.delete(`${endpoints.departments}/${id}`),
  getDepartmentsByCompanyId: (companyId: string | number) => RequestService.get(endpoints.departmentsByCompanyId(companyId)),
};

export default DepartmentsService;
